// extracted by css-extract-rspack-plugin
var _1 = "blurb__fVQUI";
var _2 = "blurb__article-link__PwIb1";
export { _1 as "blurb", _2 as "blurb__article-link" }
export default { "blurb": _1, "blurb__article-link": _2 }
